import React, { ReactNode, useState } from 'react';
import styled from 'styled-components';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';
import useCopyClipboard from 'hooks/useCopy';
import { ReactComponent as CopySVG } from 'assets/images/dashboard/copy.svg';

interface Props {
    text: string;
    className?: string;
    render?: (onCopy: () => void) => ReactNode;
    style?: React.CSSProperties;
}

const Wrapper = styled.div`
    position: relative;
    display: inline-block;
`;

const StyledCopySVG = styled(CopySVG)`
    width: 12px;
    height: 12px;
    cursor: pointer;
    flex-shrink: 0;
`;

const StyledDoneIcon = styled(DoneIcon)`
    width: 12px;
    height: 12px;
    color: ${({ theme }) => theme.c.primary01};
    cursor: pointer;
`;

const Copied = styled.div`
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 10px;
    color: #000;
    background-color: ${({ theme }) => theme.c.primary01};
    border-radius: 6px;
    padding: 2px 6px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default function Copy({ text, className, render, style }: Props) {
    const [isDone, setIsDone] = useState(false);
    const [, setCopied] = useCopyClipboard();
    const handleCopy = () => {
        setCopied(text || '');
        setIsDone(true);
        setTimeout(() => setIsDone(false), 1000);
    };

    const renderChild = (
        <>
            {render?.(handleCopy)}
            {isDone ? <Copied>Copied</Copied> : null}
        </>
    );

    const defaultChild = isDone ? (
        <>
            <StyledDoneIcon className={className} />
            <Copied>Copied</Copied>
        </>
    ) : (
        <StyledCopySVG className={className} onClick={handleCopy} />
    );
    return <Wrapper style={style}>{render ? renderChild : defaultChild}</Wrapper>;
}
